export default __webpack_public_path__ + "images/E3.3fe263a.png";